<!--
  @component ScheduleBlock — upcoming, calendar-style.
  tier:      home block (kind: "schedule")
  purpose:   a tasteful week strip + agenda. v1 has no cron data source yet, so
             the agenda is an honest, designed empty state (structure is ready
             for scheduled deploys / tasks / calendar embeds).
-->
<script lang="ts">
  const today = new Date();
  const dow = ["S", "M", "T", "W", "T", "F", "S"];
  // The current week (Sun→Sat) for the strip.
  const days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date(today);
    d.setDate(today.getDate() - today.getDay() + i);
    return d;
  });
  function isToday(d: Date): boolean { return d.toDateString() === today.toDateString(); }
</script>

<section class="block">
  <header class="bh"><h2>Schedule</h2></header>

  <div class="week" role="presentation">
    {#each days as d, i (i)}
      <div class="day" class:today={isToday(d)}>
        <span class="dl">{dow[i]}</span>
        <span class="dn">{d.getDate()}</span>
      </div>
    {/each}
  </div>

  <div class="agenda">
    <div class="ae-mark" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
        <rect width="18" height="18" x="3" y="4" rx="2" /><path d="M3 10h18M8 2v4M16 2v4" />
      </svg>
    </div>
    <p class="ae-title">Nothing scheduled</p>
    <p class="ae-sub">Scheduled deploys and tasks will show up here.</p>
  </div>
</section>

<style>
  .block {
    display: flex; flex-direction: column; gap: var(--space-4);
    background: var(--glass-fill); border: 0.5px solid var(--border);
    border-radius: var(--radius-lg, 14px); padding: var(--space-5); font-family: var(--type-font);
    height: 100%;
  }
  .bh h2 { margin: 0; font-size: 15px; font-weight: 600; letter-spacing: -0.01em; color: var(--text-primary); }

  .week { display: grid; grid-template-columns: repeat(7, 1fr); gap: 4px; }
  .day {
    display: flex; flex-direction: column; align-items: center; gap: 3px;
    padding: 7px 0; border-radius: var(--radius-md); border: 0.5px solid transparent;
  }
  .day .dl { font-size: 9.5px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; color: var(--text-ghost); }
  .day .dn { font-size: 13px; font-weight: 500; color: var(--text-tertiary); font-variant-numeric: tabular-nums; }
  .day.today { background: var(--accent-subtle, rgba(110,168,254,0.1)); border-color: var(--accent-border, rgba(110,168,254,0.3)); }
  .day.today .dl { color: var(--accent-text); }
  .day.today .dn { color: var(--text-primary); font-weight: 600; }

  .agenda {
    flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;
    text-align: center; gap: 6px; padding: var(--space-5) var(--space-3);
    border-top: 0.5px solid var(--border-subtle);
  }
  .ae-mark { width: 34px; height: 34px; color: var(--text-ghost); margin-bottom: 2px; }
  .ae-mark svg { width: 100%; height: 100%; }
  .ae-title { margin: 0; font-size: 13px; font-weight: 500; color: var(--text-secondary); }
  .ae-sub { margin: 0; font-size: 11.5px; color: var(--text-tertiary); line-height: 1.5; max-width: 200px; }
</style>
